export const enPatientTranslations = {
  Patient: {
    Header: {
      overviewItemAssign: 'Assign…',
      overviewItemSet: 'Set {{attribute}}',
      overviewItemEmpty: '—',
      overviewItemUpdated: '{{label}} updated',
      overviewItemUpdateFailed: "Couldn't update {{label}}",
      linkedValueSource: '{{source}}, {{date}}',
      linkedValueSourceLabel: 'Source: {{source}}',
      linkedValueOverridden:
        'Saved, but {{attribute}} shows {{value}}: another record takes priority.',
      linkedValueOverriddenWithSource:
        'Saved, but {{attribute}} shows {{value}} ({{source}}): another record takes priority.',
      linkedValueOverriddenDot: 'Saved, but another record takes priority',
      linkedValueUnavailable: 'Unavailable',
      linkedValueUnavailableHint: 'This value is temporarily unavailable.',
      linkedValueReadOnlyHint: "This field can't be changed here.",
      linkedValueRefreshFailed:
        "Saved, but couldn't refresh. Reload the page to see the latest value.",
      print: 'Print PDF',
      overviewItemsMore: '+{{count}}',
      overviewItemsMoreLabel_one: '{{count}} more overview item',
      overviewItemsMoreLabel_other: '{{count}} more overview items',
      overviewItemsPopoverLabel: 'More overview items',
      startDate: 'Start Date',
      lastActivity: 'Last Activity',
      patientID: 'Patient ID',
      patientMrn: 'MRN',
      importedFromEMR: 'Imported from EMR',
      age: 'Age',
      sex: 'Sex',
      diagnosis: 'Diagnosis',
      startDateNote: 'Beginning of the patient’s current episode of care.',
      lastActivityNote: `Most recent interaction in the app, including actions like viewing a
          page, recording a measurement, chatting, or being recorded by a
          clinician.`,
      lastSurgeryDate: 'Last surgery date',
    },

    Action: {
      more: 'More',
      messages: 'Messages',
      inviteToApp: 'Invite to app',
      patientProfile: 'Patient profile',
      reportFall: 'Report a fall',
      removeTestPatientStatus: 'Remove test patient status',
      setAsTestPatient: 'Set as test patient',
    },
    toastMessages: {
      patientUnset: 'Patient unset as test',
      patientSetAsTest: 'Patient set as test',
      patientFailedToSet: 'Failed to set test',
      patientFailedToUnSet: 'Failed to unset test',
    },
  },
};
